module.exports = __webpack_public_path__ + "static/media/TASK 2 if wrong.3b3d8d01.mp3";